<template>
  <v-container fluid>
    <v-card>
      <v-card-title>
        Teachers
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Search by teacher name"
          single-line
          hide-details
          @change="keywordSearch"
          clearable
          @click:append="keywordSearch"
          @click:clear="clear"
        ></v-text-field>
        <v-checkbox
          @change="loadTeachers"
          class="ml-0 ml-lg-5 pt-0 pt-lg-0"
          hide-details
          v-model="registeredOnly"
          label="Registered Only"
        />
        <v-spacer />
        <v-speed-dial class="mt-4 mt-lg-0" v-model="fab" direction="bottom">
          <template v-slot:activator>
            <v-btn v-model="fab" color="primary darken-2" dark fab>
              <v-icon v-if="fab"> mdi-close </v-icon>
              <v-icon v-else> mdi-dots-vertical </v-icon>
            </v-btn>
          </template>

          <v-btn fab dark small color="primary" :to="{ name: 'NewTeacher' }">
            <v-icon>mdi-plus</v-icon>
          </v-btn>
          <v-btn fab dark small color="primary" to="/secure/schedules">
            <v-icon>mdi-calendar</v-icon>
          </v-btn>
        </v-speed-dial>
      </v-card-title>

      <v-card-text>
        <v-data-table
          v-if="teachers != null"
          :headers="headers"
          :items="teachers"
          :items-per-page="page.itemPerPage"
          :loading="isAppLoading"
          :server-items-length="page.totalCount"
          :page="page.pageIndex"
          :disable-sort="true"
          item-key="id"
          class="elevation-1"
          @pagination="pageChanged"
        >
          <template v-slot:item.name="{ item }">
            <router-link
              data-cy="teacherlink"
              :to="{ name: 'Teacher', params: { id: item.id } }"
              >{{ item.firstName }} {{ item.lastName }}</router-link
            >

            <v-tooltip v-if="item.about" left>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" icon>
                  <v-icon>mdi-information</v-icon>
                </v-btn>
              </template>
              <span>{{ item.about }}</span>
            </v-tooltip>
          </template>

          <template v-slot:item.phone="{ item }">
            <the-mask mask="+1(###) ###-####" v-model="item.phone" />
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { TheMask } from "vue-the-mask";

export default {
  data() {
    return {
      fab: null,
      search: "",
      registeredOnly: true,
      newTeacherDialog: false,
      filterExpand: [],
      teachers: [],
      page: {
        pageIndex: 1,
        totalCount: 0,
        itemPerPage: 10,
      },
      headers: [
        {
          text: "Name",
          value: "name",
          align: "start",
          sortable: true,
        },
        {
          text: "Email",
          value: "email",
          align: "start",
          sortable: true,
        },
        {
          text: "Phone",
          value: "phone",
          align: "start",
          sortable: true,
        },
        {
          text: "Registered",
          value: "registered",
          align: "start",
          sortable: true,
        },
      ],
    };
  },
  components: {
    TheMask,
  },
  computed: {
    ...mapGetters(["navState", "isAppLoading"]),
  },
  methods: {
    ...mapActions(["addErrorMessage", "addSuccessMessage"]),
    pageChanged(pagination) {
      this.page.pageIndex = pagination.page;
      this.page.itemPerPage = pagination.itemsPerPage;
      this.loadTeachers();
    },
    loadTeachers() {
      this.$axios
        .get("/teacher", {
          params: {
            "center-id": this.centerId,
            searchTerms: this.search,
            size: this.page.itemPerPage,
            page:
              this.page.pageIndex && this.page.pageIndex > 0
                ? this.page.pageIndex - 1
                : 0,
            sort: "firstName",
            registered: this.registeredOnly ? true : null,
          },
        })
        .then((resp) => {
          this.page.totalCount = resp.data.totalElements;
          this.teachers = resp.data.content;
        })
        .catch((error) => {
          console.error(error)
          this.addErrorMessage("Error loading teachers from server");
        });
    },
    clear() {
      this.page.pageIndex = 1;
      this.search = null;
      this.loadTeachers();
    },
    keywordSearch() {
      this.page.pageIndex = 1;
      this.loadTeachers();
    },
    editTeacher(teacher) {
      console.log("edit teacher");
      console.log(teacher);
    },
    postRegisterTeacher(teacher) {
      console.log("registered teacher");
      console.log(teacher);
      const index = this.teachers.findIndex((t) => t.id == teacher.id);
      this.teachers.splice(index, 1, teacher);
    },
  },
  mounted() {
    console.log("loading teachers");
    this.loadTeachers();
  },
};
</script>

<style>
</style>